import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state(){
    return{
      loginStatus: false,
      showLogin: false,
      userId: '',
      username: '',
      currentRoute: '',
      currentChatId: '',
      isChatListCollapsed: false
    }
  },
  getters: {
  },
  mutations: {
    setLoginStatus(state, status){
      state.loginStatus = status
    },
    setShowLogin(state, status){
      state.showLogin = status
      console.log('showLogin:', state.showLogin)
    },
    setUserId(state, userId){
      state.userId = userId
    },
    setUsername(state, username){
      state.username = username
    },
    setState(state, savedState) {
      Object.assign(state, savedState);
    },
    setCurrentRoute(state, currentRoute){
      state.currentRoute = currentRoute
    },
    setCurrentChatId(state, currentChatId){
      state.currentChatId = currentChatId
    },
    setChatListCollapsed(state, isCollapsed){
      state.isChatListCollapsed = isCollapsed
    }
  },
  actions: {
    saveState() {
      localStorage.setItem('vuexState', JSON.stringify(this.state));
    }
  },
  modules: {
  },  
  plugins: [
    createPersistedState({
    paths: ['showLogin', 'userId', 'username','loginStatus'], // 只持久化这部分状态
    storage: window.localStorage // 使用localStorage，也可以使用sessionStorage
  })]
})
